import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import ComboBoxField from "./fields/ComboBoxField";
import { DueDatePickerField } from "./fields/DueDatePickerField";
import EmailField from "./fields/EmailField";
import { FieldErrors } from "./fields/FieldErrors";
import InputField from "./fields/InputField";
import MultiSelectField from "./fields/MultiSelectField";
import PhoneField from "./fields/PhoneField";
import { SearchableSelectByIdField } from "./fields/SearchableSelectByIdField";
import SelectField from "./fields/SelectField";
import { SubmitButton } from "./fields/SubmitButton";
import TextField from "./fields/TextField";

export const { fieldContext, useFieldContext, formContext, useFormContext } =
	createFormHookContexts();

export const { useAppForm, withFieldGroup, withForm } = createFormHook({
	fieldComponents: {
		TextField,
		SelectField,
		ComboBoxField,
		MultiSelectField,
		InputField,
		EmailField,
		PhoneField,
		FieldErrors,
	},
	formComponents: {
		SubmitButton,
	},
	fieldContext,
	formContext,
});

// Export field components for direct use
export {
	TextField,
	SelectField,
	ComboBoxField,
	MultiSelectField,
	InputField,
	EmailField,
	PhoneField,
	DueDatePickerField,
	SearchableSelectByIdField,
};

// Export phone field utilities
export {
	createOptionalPhoneNumberSchema,
	createPhoneNumberSchema,
	createPhoneValidators,
	formatPhoneForDisplay,
	isValidUSPhone,
	optionalPhoneNumberSchema,
	parsePhoneToRaw,
	phoneNumberSchema,
	phoneValidators,
} from "./fields/PhoneField.validators";
